<script setup lang="ts">
import { useContentSearchField } from '@/vue_components/content-search/composables/useContentSearchField';
import { useSearchList } from '../composables/useSearchList';
import { emitterInstance } from '@/classes/emitter';

/**
 * Suchkomponente mit Auto-Vervollständigung
 * Bietet Eingabefeld mit Vorschlägen und Suchfunktionalität
 */

interface Props {
  placeholder?: string;
  searchLabel?: string;
  isContentSearch: boolean;
  isSimpleSearchField:boolean;
}

const props = withDefaults(defineProps<Props>(),{
  isContentSearch:false,
  isSimpleSearchField:false});

const emit = defineEmits<{
  'search': [term:string]
}>();

const{
  placeholder: finalPlaceholder,
  searchLabel: finalSearchLabel,
  selectSuggestion,
  onBlur
} = useSearchList(props, emit);

const{
  searchTerm,
  suggestions,
  emitSearch,
  onInput,
} = props.isContentSearch ? useContentSearchField(props, emit): useSearchList(props, emit);

emitterInstance.on("updateSearchTerm", (term:any) => {
  searchTerm.value =  term as string;
})
function blubb(){
  suggestions.value=[];
  searchTerm.value = "";
           
}

</script>

<template>
  <div class="element-suche-input">
    <div class="search-roundbox">
      <div class="contentSearchBar">
        <input
            type="text"
            class="static"
            v-model="searchTerm"
            @input="onInput"
            @keyup.enter="emitSearch()"
            @blur="onBlur"
            :placeholder="finalPlaceholder"
            autocomplete="off"
        />
        <span class="suggestList-close-container">
          <button
              class="al-btn-close closeSuggestList"
              v-if="suggestions.length"
              @click="blubb"
          ></button>
        </span>
        <button class="al-btn-search-content" @mousedown.prevent="emitSearch()">
          <span>{{ finalSearchLabel }}</span>
        </button>

        <div :class="['search-list-wrapper', suggestions.length && suggestions.length>0 ? 'opened' : '']">
          <ul>
            <li
                v-for="item in suggestions"
                :key="item.SuggestedName"
                @mousedown.prevent="selectSuggestion(item)"
            >
              {{ item.SuggestedName }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>